import React from "react";
import { fade } from "@material-ui/core/styles/colorManipulator";
import { withStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";

const styles = (theme) => ({
  gridActionIcons: {
    float: "left",
    "& $actionIcon": {
      paddingLeft: 10,
      "&:not(:last-child)": {
        borderRight: `1px solid ${theme.AppBGColor}`,
        paddingRight: 10,
      },
    },
  },
  searchContainer: {
    display: "inline-block",
    position: "relative",
    marginRight: 10,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.AppBGColor, 0.25),
    "&:hover": {
      backgroundColor: fade(theme.HeaderBGColor, 0.15),
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing.unit,
      width: "auto",
    },
  },
  searchIcon: {
    color: theme.iconColor,
    width: theme.spacing.unit * 9,
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  searchInputRoot: {
    color: "inherit",
    width: "100%",
    height: 32,
    fontSize: 14,
  },
  searchInput: {
    color: theme.iconColor,
    paddingTop: theme.spacing.unit,
    paddingRight: theme.spacing.unit,
    paddingBottom: theme.spacing.unit,
    paddingLeft: theme.spacing.unit * 10,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: 120,
      "&:focus": {
        width: 200,
      },
    },
  },
});

const SearchBar = ({ classes, updateQuickFilterText }) => {
  return (
    <span className={classes.gridActionIcons}>
      <div className={classes.searchContainer}>
        <div className={classes.searchIcon}>
          <SearchIcon />
        </div>
        <InputBase
          placeholder="Search…"
          classes={{
            root: classes.searchInputRoot,
            input: classes.searchInput,
          }}
          onChange={updateQuickFilterText}
        />
      </div>
    </span>
  );
};

export default withStyles(styles)(SearchBar);
